import { Flex } from "@zenchef/styled-system/jsx";
import withTestId from "../../utils/withTestId";
import {
  aromaAvatar,
  AromaAvatarVariantProps,
} from "@zenchef/styled-system/recipes";
import Icon from "../Icon/Icon";
import AromaBadge from "../Badge/Badge";
import { Text } from "../typography/Text";
import { IconName } from "@zenchef/icomoon/dist/aromaticons/types";

export interface AvatarProps extends AromaAvatarVariantProps {
  iconName?: IconName;
  imageSrc?: string;
  badgeText?: string;
  title?: string;
  subtitle?: string;
  showAbbreviation?: boolean;
  onClick?: React.MouseEventHandler<
    HTMLDivElement | HTMLImageElement | HTMLSpanElement
  >;
}

const AromaAvatar = ({
  iconName = "placeholder-circle",
  imageSrc,
  badgeText,
  title,
  subtitle,
  showAbbreviation,
  onClick,
  ...props
}: AvatarProps) => {
  const [aromaTagVariantProps] = aromaAvatar.splitVariantProps(props);
  const classes = aromaAvatar(aromaTagVariantProps);
  const abbreviation = title
    ? title
        .split(" ")
        .map((word) => word[0].toUpperCase())
        .join("")
    : "";

  return (
    <Flex className={classes.wrap}>
      <Flex className={classes.container} onClick={onClick}>
        {imageSrc ? (
          <img className={classes.image} src={imageSrc} />
        ) : showAbbreviation && abbreviation ? (
          <Text className={classes.abbreviation}>{abbreviation}</Text>
        ) : (
          <Icon name={iconName} />
        )}
        <AromaBadge
          chip={aromaTagVariantProps.size !== "jumbo"}
          function="success"
          className={classes.badge}
        >
          {aromaTagVariantProps.size === "jumbo" && badgeText}
        </AromaBadge>
      </Flex>
      {(!!title || !!subtitle) && (
        <Flex className={classes.textWrap}>
          {title && <Text className={classes.title}>{title}</Text>}
          {subtitle && <Text className={classes.subtitle}>{subtitle}</Text>}
        </Flex>
      )}
    </Flex>
  );
};

export default withTestId("image")(AromaAvatar);
